/**
 * Class representing a configuration (user provided options)
 * for personalization
 */

import { IUserFactRulesMap } from "../Common/Models";

export class Configuration {

    private sessionId: string;
    private userFactRules: IUserFactRulesMap;

    public setSessionId(sessionId: string) {
        this.sessionId = sessionId;
    }

    public setUserFactRules(userFactRules: IUserFactRulesMap) {
        this.userFactRules = userFactRules;
    }

    public getSessionId(): string {
        return this.sessionId;
    }

    public getUserFactRules(): IUserFactRulesMap {
        return this.userFactRules;
    }
}

const configuration: Configuration = new Configuration();

/**
 * Get the current configuration
 */
export function get(): Configuration {
	return configuration;

}